module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": _vm.type
    },
    on: {
      "click": _vm.doClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33502b93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 79
// module chunks = 1